module.exports = [{
      plugin: require('/Users/marcysutton/Sites/FrontendMasters/js-a11y/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"remarkPlugins":[null,null]},
    },{
      plugin: require('/Users/marcysutton/Sites/FrontendMasters/js-a11y/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/marcysutton/Sites/FrontendMasters/js-a11y/node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/marcysutton/Sites/FrontendMasters/js-a11y/node_modules/gatsby-theme-mdx-deck/gatsby-browser.js'),
      options: {"plugins":[],"mdx":true,"contentPath":"src/slides","basePath":"/slides"},
    },{
      plugin: require('/Users/marcysutton/Sites/FrontendMasters/js-a11y/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
